import React from 'react';
import ErrorScreen from '../ErrorScreen';
import { InlineExternalLink } from '@monash/portal-react';
import c from './generic-error.module.scss';

const GenericError = ({ children }) => {
  const reportBugUrl = '/feedback';

  const body = children || (
    <>
      <p>
        The app has encountered an unexpected issue. We apologise for the
        inconvenience.{' '}
      </p>
      <p>
        Please try again later. If the issue persists,{' '}
        <InlineExternalLink
          text="report the bug here"
          mode="canvas"
          link={reportBugUrl}
        />
      </p>

      <p>Thank you for your understanding.</p>
    </>
  );

  return (
    <ErrorScreen
      illustration="brokenFlowers"
      heading="Something went wrong"
      message={<div className={c.message}>{body}</div>}
    />
  );
};

export default GenericError;
